module.exports = __webpack_public_path__ + "img/Linda Edmond Turner in phi upsilon omicron, the choir (1).0ae9d728.png";